import React, {useState} from 'react'
import api from '../utils/Api'

const useAccounting = () => {
  const [accountCodeOptions, setAccountCodeOptions] = useState<any>([])

  const fetchAccountCodes = (param = '') => {
    api.request('account/account-code', (r)=>{
      setAccountCodeOptions(r.map((item: any)=>({
        label: `${item.code} - ${item.name}`,
        value: item.code
      })))
    }, {s:param})
  }

  return {
    accountCodeOptions,
    fetchAccountCodes,
  }
}

export default useAccounting
